import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';
import Order from 'src/app/models/Order';
import { OrderStatus } from 'src/app/models/OrderStatus';
import { OrderType } from 'src/app/models/OrderType';
import { PreorderType } from 'src/app/models/PreorderType';
import { TerminalorderType } from 'src/app/models/TerminalorderType';
import { OrderService, STATUS_CHANGE } from 'src/app/services/order.service';

@Component({
	selector: 'app-order-item-status-section',
	templateUrl: './order-item-status-section.component.html',
	styleUrls: ['./order-item-status-section.component.scss'],
})
export class OrderItemStatusSectionComponent {
	public order: Order;
	public orderStatusEnum = OrderStatus;
	public type: PreorderType | TerminalorderType | null;
	preorderType = PreorderType;
	notificationTimeout: any; // Declare a variable to store the timeout ID
	public additionalInfoShow = false;
	public ot = OrderType;

	@Input() set orderValue(value: Order) {
		if (value) {
			this.order = value;
			this.type = this.orderSevice.getOrderPreorderOrTerminalType(value);
		}
	}
	@Output() sendOrderStatusChange = new EventEmitter<{
		order: Order;
		status: STATUS_CHANGE;
	}>();
	statusChangeENUM = STATUS_CHANGE;
	blockClick = false;

	constructor(
		private orderSevice: OrderService,
		private cdr: ChangeDetectorRef
	) {}
	updateStatus(order: Order, status: STATUS_CHANGE) {
		if (!this.blockClick) {
			this.blockButton();
			this.sendOrderStatusChange.emit({ order, status });
		}
	}
	formatTime(isAsap: boolean, time?: string) {
		if (isAsap && !time) {
			return 'schnellstmöglich';
		}
		if (!time) {
			return;
		}
		return moment(time).format('HH:mm DD/MM');
	}
	blockButton() {
		this.blockClick = true;
		clearTimeout(this.notificationTimeout);

		// Set a new timeout

		this.notificationTimeout = setTimeout(() => {
			console.log('BLOCK CLIKC CHANGE', this.blockClick);
			this.blockClick = false;
			console.log('BLOCK CLIKC CHANGE 2', this.blockClick);
			this.cdr.detectChanges();
		}, 2000);
	}

	toggleAdditionalInfo() {
		this.additionalInfoShow = !this.additionalInfoShow;
	}
}
